import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["items", "empty", "continueButton"]

  connect() {
    this.products = new Map()
    this.refreshState = this.refreshState.bind(this)

    this.itemsTarget.querySelectorAll("[data-cart-product-id]").forEach((row) => {
        const id = row.dataset.cartProductId
        const amount = parseInt(row.querySelector("[data-cart-amount-input]").value, 10) || 1
        const stock = parseInt(row.dataset.cartProductStock, 10) || 0

        this.products.set(id, { id: id, amount: amount, stock: stock })
    })

    document.addEventListener("turbo:frame-load", this.refreshState)
    this.refreshState()
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.refreshState)
  }

  add(event) {
    const button = event.currentTarget
    const id = button.dataset.productId
    const stock = parseInt(button.dataset.productStock, 10) || 0

    if (stock <= 0) {
      window.alert("This product is out of stock.")
      return
    }

    if (this.products.has(id)) {
      const product = this.products.get(id)

      if (product.amount >= product.stock) {
        window.alert("You cannot add more products than are available in stock.")
        return
      }

      product.amount += 1
      this.updateRow(id, product)
    } else {
      const product = {
        id: id,
        code: button.dataset.productCode,
        name: button.dataset.productName,
        category: button.dataset.productCategory,
        amount: 1,
        stock: stock
      }

      this.products.set(id, product)
      this.addRow(product)
    }

    this.refreshState()
  }

  remove(event) {
    const id = event.currentTarget.dataset.productId
    this.products.delete(id)

    const row = this.itemsTarget.querySelector(`[data-cart-product-id="${id}"]`)
    if (row) row.remove()

    this.refreshState()
  }

  increment(event) {
    const id = event.currentTarget.dataset.productId
    const product = this.products.get(id)

    if (product.amount >= product.stock) {
      window.alert("You cannot add more products than are available in stock.")
      return
    }

    product.amount += 1
    this.updateRow(id, product)
  }

  decrement(event) {
    const id = event.currentTarget.dataset.productId
    const product = this.products.get(id)

    product.amount -= 1

    if (product.amount <= 0) {
      this.products.delete(id)
      this.itemsTarget.querySelector(`[data-cart-product-id="${id}"]`)?.remove()
    } else {
      this.updateRow(id, product)
    }

    this.refreshState()
  }

  addRow(product) {
    this.itemsTarget.insertAdjacentHTML("beforeend", `
      <tr data-cart-product-id="${product.id}" data-cart-product-stock="${product.stock}">
        <td>${this.escape(product.code)}</td>
        <td>${this.escape(product.name)}</td>
        <td>
          <button type="button" class="btn btn-sm btn-secondary" data-action="service-order-cart#decrement" data-product-id="${product.id}">-</button>
          <span class="mx-2" data-cart-amount>${product.amount}</span>
          <button type="button" class="btn btn-sm btn-secondary" data-action="service-order-cart#increment" data-product-id="${product.id}">+</button>

          <input form="service_order_review_form" type="hidden" name="service_order[lines_attributes][][product_id]" value="${product.id}">
          <input form="service_order_review_form" type="hidden" name="service_order[lines_attributes][][amount]" value="${product.amount}" data-cart-amount-input>
        </td>
        <td class="text-right">
          <button type="button" class="btn btn-sm btn-link text-danger" data-action="service-order-cart#remove" data-product-id="${product.id}">
            <i class="la la-trash"></i>
          </button>
        </td>
      </tr>
    `)
  }

  updateRow(id, product) {
    const row = this.itemsTarget.querySelector(`[data-cart-product-id="${id}"]`)
    row.querySelector("[data-cart-amount]").textContent = product.amount
    row.querySelector("[data-cart-amount-input]").value = product.amount
  }

  refreshState() {
    const hasProducts = this.products.size > 0

    this.emptyTarget.classList.toggle("d-none", hasProducts)
    this.continueButtonTarget.disabled = !hasProducts
  }

  escape(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;")
  }
}
